import { defineComponent as _defineComponent } from 'vue'
import FormContainer from "../shared/FormContainer.vue"
import CountrySelect from "@/components/widgets/input/CountrySelect.vue"
import { PropType, ref } from "vue"
import { Theme } from "@/types"
import { THEMES, CompanySizeRange, OwnershipStructure } from "@/constants"
import { ClientInput } from "@/gql"
import { useOnboardingContext } from "../shared/useOnboardingContext"
import IndustriesSelect from "@/components/widgets/input/IndustriesSelect.vue"


export default /*#__PURE__*/_defineComponent({
  __name: 'CompanyInfoForm',
  props: {
  isSubmitting: {
    type: Boolean,
    default: false,
  },
  submitButtonText: {
    type: String,
    default: "Done",
  },
  theme: {
    type: Object as PropType<Theme>,
    default: () => ({
      primaryColor: THEMES.PERALTA_PRIMARY,
      iconColor: THEMES.PERALTA_PRIMARY_RED,
    }),
    required: false,
  },
},
  emits: ["gotoNext", "gotoPrev", "change"],
  setup(__props, { emit }) {




const form = ref<ClientInput>({
  name: "",
  website: "",
  countryId: "",
  address: "",
  companySizeRange: null,
  ownershipStructure: null,
  industry: null,
  description: "",
})

const observer = ref(null)

const { updateOnboardingForm } = useOnboardingContext()

const onSubmit = async () => {
  const validity = await (observer.value as any)?.validateWithInfo()
  if (!validity.isValid) return

  updateOnboardingForm({
    newClientInput: form.value,
  })

  emit("gotoNext")
}

return { __sfc: true,emit, form, observer, updateOnboardingForm, onSubmit, FormContainer, CountrySelect, CompanySizeRange, OwnershipStructure, IndustriesSelect }
}

})